export default __webpack_public_path__ + "static/media/sybb.14264ffe.png";